import Vue from 'vue'
import Vuex from 'vuex'
import get from "@/api/get";
import qs from "qs";
import getPad from "@/utils/getPad";
import isMobile from '@/utils/isMobile'
Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        integralFlag: true,//我的任务积分兑换功能开关
        isInGame: location.href.indexOf('roleid=') != -1 ? true : false,//游戏内
        isXcx: location.href.indexOf('login=') != -1 ? true : false,
        bindIconShow: JSON.parse(localStorage.getItem('bindIconShow')) || false, //获取绑定码入口
        bindCodeShow: JSON.parse(localStorage.getItem('bindCodeShow')) || false, //设置绑定码入口
        bindPhoneShow: JSON.parse(sessionStorage.getItem('userObj'))?.bindPhoneView == 1 ? true : false,//设置手机绑定入口
        xcxLoginChoose: false,//钢岚小程序双账号弹窗
        loginShow: false, //调取登录组件
        // loginStatus: JSON.parse(sessionStorage.getItem('userObj'))?.loginStatus ? 1 : 0,//0未登录 1登录
        loginStatus: 0,//0未登录 1登录
        isPad: getPad() == 'ipad' ? true : false,//判断pad
        isMobile: isMobile(),//判断pad
        gameType: 0, //1 龙之国  2钢岚 3第七史诗 4龙魂旅人 5ROX
        gameAppkeyArr: ['', '1504685273578', '1705460260139', '1611630374326', '1656417299063', '1693534261653'],//游戏对应appkey
        token: '',
        connectionFlag: false,//断网判断
        connectionOpenGame: [],//不加断网的项目gameType,配合connectionFlag的值使用（true+n在n下不显示断网）
        navSubList: [],
        messageNum: 0,//底部tab消息未读
        memberId: 0,//当前用户memberId
        status: 0,//0启用，1禁言中，2封禁中
        bannedText: '',//封禁原因
        refresh: false,//判断首页是否刷新
        messageCache: false,//判断消息页是否刷新
        // imgThumb: '?imageMogr2/thumbnail/!50p',//图片缩略图字段
        imgThumb: '?imageMogr2/format/webp',//图片缩略图字段
        system: '',
        userObj: {},
        anchorFlag: false,//详情页锚点标识
        tipFlag: false,//控制發布成功弹框
        padFlag: '',//判断pad、pc
        openId: '',//微信内登陆时获取的openId
        // status: 0//当前用户状态
        postingFlag: true, //用户发帖发言标识    true:可以发帖
        wxProgram: false,//检测当前是否在小程序环境中
        videoProgress: 0, // 当前视频的播放进度
        videoId: '', // 当前播放视频的id
        isU3d: getPad() === 'u3d' || getPad() === 'u3dPc' ? true : false,
        isUpVideoShow: false,
        // videoDefaultCover: require('../assets/img/rich/cover.jpg')

    },
    mutations: {
        changeGameType(state, val) {
            switch (true) {
                case location.href.indexOf('epic7-community.zlongame.com') != -1 ||
                    location.href.indexOf(state.gameAppkeyArr[3]) != -1: state.gameType = 3
                    break;
                case location.href.indexOf('ma-community.tentree-games.com') != -1 ||
                    location.href.indexOf(state.gameAppkeyArr[2]) != -1: state.gameType = 2
                    break;
                case location.href.indexOf('lhlr-community.zlongame.com') != -1 ||
                    location.href.indexOf(state.gameAppkeyArr[4]) != -1: state.gameType = 4
                    break;
                case location.href.indexOf('rox-community.zlongame.com') != -1 ||
                    location.href.indexOf(state.gameAppkeyArr[5]) != -1: state.gameType = 5
                    break;
                default: state.gameType = 1
                    break;
            }
        },
        changeXcxLoginChoose(state, val) {
            state.xcxLoginChoose = val
        },
        changeBannedText(state, val) {
            state.bannedText = val
        },
        changeWxProgram(state, val) {
            state.wxProgram = val
        },
        changeBindIconShow(state, val) {
            state.bindIconShow = val
        },
        changeBindCodeShow(state, val) {
            state.bindCodeShow = val
        },
        changeBindPhoneShow(state, val) {
            state.bindPhoneShow = val
        },
        changeLoginShow(state, val) {
            if (val && state.wxProgram && !state.xcxLoginChoose && !window.user.login) {
                wx.miniProgram.navigateTo({
                    url: "/pages/index/index",
                });
            } else {
                state.loginShow = val
                state.xcxLoginChoose = false
            }
        },
        changeLoginStatus(state, val) {
            state.loginStatus = val
        },
        setUserInfo(state, obj) {
            //初始用户信息
            if (!state.token) { //未读取到cookie
                state.token = obj.token
            }
            state.navSubList = obj.navSubList
            state.messageNum = obj.unReadNum
            if (obj.memberId) {
                state.memberId = obj.memberId
            } else {
                let arr = document.cookie.split(";")
                for (var i = 0; i < arr.length; i++) {
                    // trim:删除空格，按照等号分割，得到[键，名]的数组
                    var t = arr[i].trim().split("=");
                    // 判断键是否相等，返回相应的值
                    if (t[0] === '_pd_bf') {
                        state.memberId = t[1].split('#')[0]
                    }
                }
            }
            if (state.status) {
                state.status = obj.status
            }
            state.userObj = JSON.parse(JSON.stringify(obj))
        },
        changeMemberId(state, val) {
            state.memberId = val
        },
        changeMessageNum(state, [num, flag]) {
            //底部消息tab未读数量改变
            if (flag) {
                state.messageNum = num
            } else {
                state.messageNum = state.messageNum - num
            }
        },
        changeToken(state, value) {
            state.token = value
        },
        changeStatus(state, id) {
            state.status = id
        },
        changeOpenId(state, id) {
            state.openId = id
        },
        connectionChang(state, flag) {
            state.connectionFlag = flag
            // state.connectionFlag = true
        },
        changeRefresh(state, flag) {
            state.refresh = flag
        },
        changeMessageCache(state, flag) {
            state.messageCache = flag
        },
        changetipFlag(state, flag) {
            //修改發布成功弹框
            state.tipFlag = flag
        },
        changeAnchorFlag(state, anchorFlag) {
            state.anchorFlag = anchorFlag
        },
        // 设置当前视频播放的时间
        setVideoProgress(state, current) {
            state.videoProgress = current
        },
        // 设置当前视频id
        setVideoId(state, id) {
            state.videoId = id
        },
        setUpVideoShow(state, boo) {
            state.isUpVideoShow = boo
        },
    }
})
